// src/components/Loading/index.tsx
'use client';

import React from 'react';
import styles from '@/styles/load.module.css';

const Loading: React.FC = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.loaderContent}>
        {/* Logo */}
        <img 
          src="/images/logo_clear.png" 
          alt="Qwetulands" 
          className={styles.logo}
        />
        
        {/* Loader Animation */}
        <div className={styles.loader}>
          <div className={styles.bars}>
            {[...Array(3)].map((_, index) => (
              <span key={index} className={styles.bar} />
            ))}
          </div>
          <div className={styles.loadingText}>Loading...</div>
        </div>
      </div>
      
      {/* Background Elements */}
      <div className={styles.backgroundElements}>
        <div className={styles.gradientOrb1} />
        <div className={styles.gradientOrb2} />
        <div className={styles.gradientOrb3} />
      </div>
    </div>
  );
};

export default Loading;